type ActivityLike = {
  activityId?: string | null;
};

type DayLike = {
  activities?: ActivityLike[];
};

type ItineraryLike = { days?: DayLike[] } | null | undefined;

export const getItineraryActivityIds = (itinerary: ItineraryLike): string[] => {
  if (!itinerary?.days) return [];

  const activityIds = new Set<string>();

  itinerary.days.forEach((day) => {
    day.activities?.forEach((activity: ActivityLike) => {
      if (activity.activityId) {
        activityIds.add(activity.activityId);
      }
    });
  });

  return Array.from(activityIds);
};

export const getBookedActivityIds = (
  itineraries: ItineraryLike[] | null | undefined
): Set<string> => {
  const bookedActivityIds = new Set<string>();

  itineraries?.forEach((itinerary) => {
    getItineraryActivityIds(itinerary).forEach((activityId) => {
      bookedActivityIds.add(activityId);
    });
  });

  return bookedActivityIds;
};
